import { connect } from 'react-redux'

import { MAX_RESULT, POS_ZOOM_LEVEL } from '../../settings/pointOfSale';

import { baseUrl } from '../../services/url';
import {
  mapIsReady,
  selectPointOfSale,
  updateMarkersInBounds,
  updateVisibleMarkers,
  zoomChanged
} from '../../actions/pointOfSale';

import DiorMap from 'ui-kit/src/components/DiorMap/DiorMap';

const mapStateToProps = (state) => {
  const props = {};

  const diorShops = state.pointOfSale.searchResults
    .filter(item => item.typeParent === 'Dior')
    .map(item => item.id);
  const otherShops = state.pointOfSale.searchResults
    .filter(item => item.typeParent !== 'Dior')
    .map(item => item.id);
  props.idsWithLabels = diorShops.concat(otherShops);

  if (state.pointOfSale.selectedId) {
    props.selectedMarker = state.pointOfSale.selectedId;
  }

  props.api = state.pointOfSale.api;
  props.baseUrl = baseUrl;
  props.location = state.pointOfSale.searchViewport;
  props.center = state.pointOfSale.searchPosition;
  props.zoom = state.pointOfSale.zoom;
  props.markers = state.pointOfSale.items;
  props.itinerary = state.pointOfSale.itinerary;
  props.isMapReady = state.pointOfSale.isMapReady;
  props.isMobileShopOpen = state.pointOfSale.isMobileShopOpen;
  props.maxResult = MAX_RESULT;
  props.maxZoom = POS_ZOOM_LEVEL - 1;
  props.displayType = state.shared.displayType;
  props.bounds = state.pointOfSale.searchResultsViewport;
  return props;
};

const mapDispatchToProps = (dispatch) => {
  return {
    mapReady: mapIsReady.bind(null, dispatch),
    markerClicked: function() {
      // Clicked marker is bound to "this".
      selectPointOfSale(dispatch, this.key);
    },
    updateMarkersInBounds: updateMarkersInBounds.bind(null, dispatch),
    updateVisibleMarkers: updateVisibleMarkers.bind(null, dispatch),
    zoomChanged: zoomChanged.bind(null, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DiorMap);



// WEBPACK FOOTER //
// ./src/components/StatefulDiorMap/StatefulDiorMap.jsx